
<div class="mt-1 overflow-hidden flex-w-full px-2 py-1 field-container">
    <ng-container *ngIf="parentId">
        <div class="items-center justify-between ng-star-inserted">
            <div>
                <app-drake-view-standard [scope]="childScope" [viewConfig]="childScopeView" [baseData]="quickAddBaseData" [readonly]="false" [forcedId]="linkedId" (fieldValueChanged)="onChange($event)"></app-drake-view-standard>
            </div>
        </div>
        <div class="items-center justify-between ng-star-inserted" *ngIf="standAlone">
            <div class="button-container">
                <button type="button" (click)="quickAddSave()" kendoButton class="save-button">
                    <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
                    {{ 'quickAdd.save' | transloco }}
                </button>
            </div>
        </div>
    </ng-container>
    
    <div *ngIf="!parentId">
        <fuse-alert [type]="'warning'">
            <span fuseAlertTitle>{{'common.mustSaveTitle' | transloco}}</span>
            {{(readonly ? 'common.mustSelectDescription' : 'common.mustSaveDescription') | transloco}}
        </fuse-alert>
    </div>
</div>
